import React from "react";
import { Link } from "react-router-dom";

const SingleProduct = (props) => {
  const {
    photoURL,
    productDescription,
    productName,
    productPrice,
    productQuantity,
    _id,
  } = props?.info;
  const slug=`/product/${_id}`

  if(productDescription.length > 60){
    productDescription.substring(0,60)
  }

  return (
    <div className="rounded">
      <div >
        <div className="product-grid shadow rounded ">
          <div className="product-image">
            <Link to={slug} className="image">
              <img className="pic-1" src={photoURL} alt="" />
            </Link>
            <span className="product-hot-label">{productQuantity} Left</span>
            <Link to={slug} className="add-to-cart" href="#">
              View Product
            </Link>
            <ul key={Math.random()} className="product-links rounded">
              <li key={Math.random()} >
                <Link to="#" data-tip="Add to Wishlist">
                  <svg
                    width={15}
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z"
                    />
                  </svg>
                </Link>
              </li>
              <li>
                <Link to={`/product/edit/${_id}`} data-tip="Edit">
                  <svg
                    style={{ width: "20px" }}
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                    />
                  </svg>
                </Link>
              </li>
              <li>
                <Link 
                  to={slug}
                  data-tip="Quick View"
                  data-rel="lightcase:myCollection"
                >
                  <svg
                    style={{ width: "20px" }}
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V15a2 2 0 01-2 2h-2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2v-2"
                    />
                  </svg>
                </Link>
              </li>
            </ul>
          </div>
          <div className="product-content d-flex flex-column">
            <span className="product-category">
              <Link to={slug}>{productName}</Link>
            </span>
            <div className="title text-black">
              <p className="text-wrap">{ productDescription.length > 80?productDescription.substring(0,80):productDescription} ...</p>
            </div>
            <div className="price ">Price: ${productPrice}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SingleProduct;
